import React from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { Button } from "@progress/kendo-react-buttons";
import Chip from "@mui/material/Chip";

// The working list for the two prizes nobody can pay out automatically. Everything needed to post
// one is on the row: who won, where they work, how to reach them and what they won.
//
// Paging is a backend parameter, so the rows here are exactly the page asked for and nothing is
// filtered in the browser.

const money = (value) =>
     new Intl.NumberFormat("en-GB", {
          style: "currency",
          currency: "GBP",
          maximumFractionDigits: 0,
     }).format(value || 0);

const date = (value) => (value ? new Date(value).toLocaleDateString() : "");

export default function LcvManualPrizeWinsGrid(props) {
     const { wins, totalCount, page, isBusy, onPageChange, onMarkFulfilled } = props;

     return (
          <Grid
               data={wins}
               className="sba-area-data-grid"
               skip={page.skip}
               take={page.take}
               total={totalCount}
               pageable={{ buttonCount: 4, pageSizes: [10, 25, 50] }}
               onPageChange={(event) => onPageChange(event.page)}
          >
               <GridColumn
                    title="Winner"
                    width="200px"
                    cells={{
                         data: (cellProps) => (
                              <td>
                                   {cellProps.dataItem.firstName} {cellProps.dataItem.lastName}
                              </td>
                         ),
                    }}
               />
               <GridColumn field="email" title="Email" width="240px" />
               <GridColumn field="dealerName" title="Dealer" width="200px" />
               <GridColumn field="prizeName" title="Prize" width="180px" />
               <GridColumn
                    field="prizeValueGbp"
                    title="Value"
                    width="110px"
                    cells={{
                         data: (cellProps) => <td>{money(cellProps.dataItem.prizeValueGbp)}</td>,
                    }}
               />
               <GridColumn
                    field="wonOn"
                    title="Won"
                    width="130px"
                    cells={{
                         data: (cellProps) => <td>{date(cellProps.dataItem.wonOn)}</td>,
                    }}
               />
               <GridColumn
                    field="isFulfilled"
                    title="Sent"
                    width="150px"
                    cells={{
                         data: (cellProps) => (
                              <td>
                                   {cellProps.dataItem.isFulfilled ? (
                                        <Chip
                                             size="small"
                                             color="success"
                                             label={date(cellProps.dataItem.fulfilledOn)}
                                        />
                                   ) : (
                                        <Chip size="small" variant="outlined" label="Not sent" />
                                   )}
                              </td>
                         ),
                    }}
               />
               <GridColumn field="itemSupplied" title="Item supplied" width="200px" />
               <GridColumn
                    title="Fulfilment"
                    width="170px"
                    cells={{
                         data: (cellProps) => (
                              <td>
                                   <Button
                                        type="button"
                                        disabled={isBusy}
                                        onClick={() => onMarkFulfilled(cellProps.dataItem)}
                                   >
                                        {cellProps.dataItem.isFulfilled ? "Correct" : "Mark as sent"}
                                   </Button>
                              </td>
                         ),
                    }}
               />
          </Grid>
     );
}
